import angular from 'angular';
import assetFinanceQuickProductFinder from './assetFinanceQuickProductFinder';

export default angular
  .module('components.assetFinanceQuickProductFinder', [])
  .component('assetFinanceQuickProductFinder', assetFinanceQuickProductFinder)
  .name;
